// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"h8-z"};